"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTimer = selectTimer;

var _constants = require("../constants");

function selectModule(state) {
  return state[_constants.TIMER_MODULE_NAME];
}

function selectTimerState(state) {
  return selectModule(state).timer;
}

function selectTimer(state, stageId) {
  return selectTimerState(state).timerList[stageId];
}